(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    const candidates = document.querySelectorAll('deferred-media[data-lazy-video]');
    if (!candidates.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const media = entry.target;
          observer.unobserve(media);

          const videoContainer = media.querySelector('[data-ref="deferred-media-video"]');
          const template = media.querySelector('template');
          if (!videoContainer || !template || videoContainer.children.length > 0) return;

          videoContainer.appendChild(template.content.cloneNode(true));

          // Forcer la lecture si autoplay
          const videoEl = videoContainer.querySelector('video');
          if (videoEl) {
            videoEl.muted = true;
            videoEl.play().catch(() => {});
          }
        });
      },
      { rootMargin: '200px' }
    );

    candidates.forEach((el) => observer.observe(el));
  })();
  } catch(e) { console.error(e); }
})();

})();
